import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useUmbrella } from '@modules-deprecated/app/umbrellas'

import { NavigationVariant } from '../../../../types/navigationVariant'
import { OrganizationAvatar } from '../../../OrganizationAvatar'
import { UmbrellaAvatar } from '../../../UmbrellaAvatar'

interface OrganizationDropdownIconProps {
  shouldShowBackButton: boolean
  variant?: NavigationVariant
}

export const OrganizationDropdownIcon = ({ shouldShowBackButton, variant }: OrganizationDropdownIconProps) => {
  const { umbrella } = useUmbrella()
  const { organization } = useUserOrganization()

  if (shouldShowBackButton) {
    return null
  }

  if (umbrella) {
    return <UmbrellaAvatar logoId={umbrella.logoFileId ?? undefined} variant={variant} />
  }

  return (
    <OrganizationAvatar
      organizationId={organization?.id}
      organizationName={organization?.name}
      src={organization?.iconUrl}
    />
  )
}
